import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

interface Information {
    id: string;
    tag: string;
    title: string;
    contents: string;
    priority: number;
}

export default function InformationList() {
    const navigate = useNavigate();
    const [informations, setInformations] = useState<Information[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const infoRef = collection(db, 'infomation');
                const snapshot = await getDocs(infoRef);

                const infoData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                } as Information));

                // Sort client-side
                infoData.sort((a, b) => {
                    const pA = a.priority || 999;
                    const pB = b.priority || 999;
                    return pA - pB;
                });

                setInformations(infoData);
            } catch (error) {
                console.error("Error fetching information:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchInfo();
    }, []);

    const getTagColor = (tag: string) => {
        if (tag === '重要') return 'bg-[#6B96C3] text-white';
        if (tag === 'INFO') return 'bg-[#F4B183] text-white';
        return 'bg-gray-200 text-gray-700';
    };

    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            {/* Header */}
            <header className="bg-white sticky top-0 z-10 border-b border-gray-100">
                <div className="max-w-md mx-auto px-4 h-14 flex items-center">
                    <button
                        onClick={() => navigate('/home')}
                        className="w-10 h-10 flex items-center justify-center -ml-2 text-gray-600"
                    >
                        <i className="ri-arrow-left-s-line text-2xl"></i>
                    </button>
                    <h1 className="flex-1 text-center font-bold text-gray-800 pr-8">
                        お知らせ一覧
                    </h1>
                </div>
            </header>

            <main className="max-w-md mx-auto px-4 py-6">
                {loading ? (
                    <div className="text-center py-10 text-gray-500">読み込み中...</div>
                ) : (
                    <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
                        {informations.map((info, index) => (
                            <button
                                key={info.id}
                                onClick={() => navigate(`/information/${info.id}`)}
                                className={`w-full text-left p-4 flex items-center gap-3 hover:bg-gray-50 transition-colors ${index !== informations.length - 1 ? 'border-b border-gray-100' : ''}`}
                            >
                                <span className={`px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap ${getTagColor(info.tag)}`}>
                                    {info.tag}
                                </span>
                                <p className="text-sm text-gray-700 flex-1 line-clamp-1">
                                    {info.title}
                                </p>
                                <i className="ri-arrow-right-s-line text-gray-400 text-xl"></i>
                            </button>
                        ))}
                        {informations.length === 0 && (
                            <div className="p-6 text-center text-gray-400 text-sm">
                                お知らせはありません
                            </div>
                        )}
                    </div>
                )}
            </main>
        </div>
    );
}
